import { getCachedIdDocFace } from 'utils/idDocFace';

type FacePhotoCustomer = {
  facePhoto?: string | null
  idDocUrl?: string | null
};

/** Customer face for reports / CRM — seeded facePhoto or cached ID-doc crop. */
export const guestFacePhotoUrlFromCustomer = (
  customer: FacePhotoCustomer | null | undefined,
): string | null => {
  if (!customer) return null;
  if (customer.facePhoto) {
    if (
      customer.facePhoto.startsWith('data:')
      || customer.facePhoto.startsWith('http')
    ) {
      return customer.facePhoto;
    }
    return `https://storage.googleapis.com/images_wiegfbiwudjdvh/${customer.facePhoto}`;
  }
  return getCachedIdDocFace(customer.idDocUrl) || null;
};
